/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import { useState } from 'react';
import { useContext } from 'react';
import tw from 'twin.macro';

import { FAQInvest } from '@/app/utils/containerInfo';
import { BigTitle } from '@/components';
import { DeviceInfoContext } from '@/contexts/device-info-context';

import RevealingQAContainer from '../revealing-qa-container';

function LandingInvestQA() {
  const [activeTab, setActiveTab] = useState(0);
  const [open, setOpen] = useState(false);
  const { isMobile } = useContext(DeviceInfoContext);
  const tabs = [
    'Открытие и получение',
    'Использование',
    'Инвестирование',
    'Снятие, пополнение и переводы',
    'Налоговые и юридические вопросы',
    'Решение проблем'
  ];
  return (
    <div>
      <BigTitle
        text={'Вопросы и ответы по карте'}
        twStyle={tw`sm:text-[34px] text-[24px] text-[#70FF6E] sm:mb-20 mb-10`}
      />
      {isMobile ? (
        <div tw='flex flex-col gap-5'>
          {tabs?.map((item, i) => (
            <>
              <p
                key={item.question}
                tw='text-[18px]'
                css={activeTab === i && tw`text-[#70FF6E]`}
                onClick={() => setActiveTab(i)}
              >
                {item}
              </p>
              {activeTab === i && (
                <div tw='flex flex-col divide-y divide-grey w-full border-t border-[#8e8e93]'>
                  {FAQInvest[activeTab].map(item => (
                    <RevealingQAContainer qa={item} key={item.question} />
                  ))}
                </div>
              )}
            </>
          ))}
        </div>
      ) : (
        <div tw='flex gap-10'>
          <div tw='flex flex-col gap-5'>
            {tabs?.map((item, i) => (
              <p
                key={item.question}
                tw='text-[18px] cursor-pointer'
                css={activeTab === i && tw`text-[#70FF6E]`}
                onClick={() => setActiveTab(i)}
              >
                {item}
              </p>
            ))}
          </div>
          <div tw='flex flex-col divide-y divide-grey w-full border-t border-[#8e8e93]'>
            {FAQInvest[activeTab].map(item => (
              <RevealingQAContainer qa={item} key={item.question} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default LandingInvestQA;
